export const edicion = (state = {}, action) => {

    var today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = today.getFullYear();

    //const ff = dd + '/' + mm + '/' + yyyy;
    const ff = yyyy + '-' + mm + '-' + dd;

    //const { tercero } = action.value;

    //console.log("fuck!" + JSON.stringify(tercero));

    //debugger; setEditarTercero clearEditarTercero

    switch (action.type) {
        case "setEditarTercero": const obj = { ...action.value };
            return { ...state, tercero: obj };
        case "clearEditarTercero": const objLimpio = {
            terceroID: "",
            documentoTipoID: "",
            documentoTipoDescripcion: "",
            terceroDocumento: "",
            terceroMail: "",
            terceroTel: "",
            terceroCel: "",
            terceroDireccion: "",
            terceroAudFecha: "",
            terceroAudEstado: "",
            terceroAudVersion: "",
            terceroPassword: "",
            grupoID: "",
            terceroMailFO: "",
            terceroMailL: "",
            municipioCodigo: "",
            terceroContacto: "",
            grupoNombre: "",
            municipioDescripcion: "",
            terceroNombre: "",
            terceroNombre1: "",
            terceroNombre2: "",
            terceroApellido1: "",
            terceroApellido2: "",
        };
            return { ...state, tercero: objLimpio };

        case "setEditarProvidencia": const objProvidencia = { ...action.value };
            return { ...state, providencia: objProvidencia };

        case "setNuevaProvidencia":

            const objProvidenciaLimpio = {
                fecha: ff,
            };
            return { ...state, providencia: objProvidenciaLimpio };

        default:
            return state;
    }
}